// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"OrderModal_backdrop__2giDI","modal-container":"OrderModal_modal-container__3LR4U","modal":"OrderModal_modal__yWMRS","modal-icon":"OrderModal_modal-icon__1ouQE"};